import React from 'react';
import { PaymentMethod } from '../utils/Primitives';

interface FundsNeededProps {
  paymentMethod: PaymentMethod
}

const FundsNeeded: React.FC<FundsNeededProps> = ({ paymentMethod }) => {
  const getBuyLink = () => {
    if (Number(paymentMethod.id) === 0) {
      return 'https://www.coinbase.com/price/ethereum';
    }
    return `https://app.uniswap.org/swap?outputCurrency=${paymentMethod.address}&chain=base`;
  };

  return (
    <a
      href={getBuyLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-4 inline-block px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
    >
      Buy {paymentMethod.symbol}
    </a>
  );
};

export default FundsNeeded;
